var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_c('div',{staticClass:"inner"},[_vm._m(0),_c('p',[_vm._v("PAGE NOT FOUND")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("GO MAIN")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"colorRed"},[_c('span',[_vm._v("404 ERRER")])])
}]

export { render, staticRenderFns }